import React, { useState, useEffect, useRef } from "react";
import ReusableModal from "../../../ExtraComponents/ReusableModal";
import { getServiceApplicable } from "../../../ReduxStore/Slice/Pricing/ServiceSlice";
import { useDispatch } from "react-redux";
import Select from "react-select";
// import { allServiceList  } from "../../../ReduxStore/Slice/Pricing/ChargeBasisSlice";
import { allPackageService } from "../../../ReduxStore/Slice/Pricing/ChargeBasisSlice";
import { getSinglePackage, updatePackage } from "../../../ReduxStore/Slice/Pricing/PackageSlice";
import {
  EMPTY_PACKAGE_NAME_ERROR,
  EMPTY_APPLICABLE_TO_ERROR,
  EMPTY_TOTAL_COST_OF_SERVICES_ERROR,
  EMPTY_DEFAULT_PACKAGE_PRICE_ERROR,
  EMPTY_DEFAULT_DISCOUNT_ERROR,
  EMPTY_THRESHOLD_PRICE_ERROR,
  EMPTY_MINIMUM_PRICE_ERROR,
  EMPTY_THRESHOLD_DISCOUNT_ERROR,
  EMPTY_MAXIMUM_DISCOUNT_ERROR,
} from "../../../Utils/Common_Error";
import sweatalert from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import { ScrollToViewFirstError } from "../../../Utils/CommonFun";
const EditPackage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const user_id = JSON.parse(localStorage.getItem("details")).id;
  const token = localStorage.getItem("token");
  const textareaRef = useRef(null);
  const [serviceApplicableData, setServiceApplicableData] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [allServiceData, setAllServiceData] = useState([]);
  const [checkedList, setcheckedList] = useState([]);
  const [error, setError] = useState({});
  const [text, setText] = useState("");

  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");


  const isSelAssement = checkedList?.some(service =>
    service?.ServiceChargeBases?.some(cb =>
      cb?.ChargeBasis?.BasisType?.id === 5
    )
  )

  const [existEenterDefaultValue, setExistEenterDefaultValue] = useState([]);
  const [existServiceIds, setExistServiceIds] = useState([]);
  const [enterDefaultValue, setEnterDefaultValue] = useState([]);

  const [serviceData, setServiceData] = useState({
    packageName: "",
    status: "1",
    applicableTo: [],
    addServices: "",
    PackageDescription: "",
    DefaultPrice: "",
    MinimunPrice: "",
    TotalCost: "",
    MaximumDiscount: "",
    DefaultDiscount: "",
    qualifying_condition: "0",
    calculation_self_assessment: 1,
  });





  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height =
        textareaRef.current.scrollHeight + "px";
    }
  }, [serviceData.PackageDescription]);

  useEffect(() => {
    getPackageById();
    ServiceApplicable();
  }, []);

  const getPackageById = async () => {
    const req = { id: location?.state?.row?.id || id, agent_id: agent_id };
    try {
      const response = await dispatch(getSinglePackage(req)).unwrap();

      if (response.status) {
        const packageDetails = response.data || {};
      
        const serviceIds = packageDetails?.PackageServices?.map(item => item.service_id) || [];
     
        setExistEenterDefaultValue(packageDetails?.PackageEnterDefaultValues || []);
        setExistServiceIds(serviceIds);

        setServiceData({
          ...serviceData,
          packageName: packageDetails?.name,
          status: packageDetails?.status,
          applicableTo: packageDetails?.applicable
            ? packageDetails?.applicable.split(',').map(item => ({ label: item.trim(), value: item.trim() }))
            : [],
          PackageDescription: packageDetails?.description,
          DefaultPrice: packageDetails?.default_price,
          MinimunPrice: packageDetails?.min_price,
          TotalCost: packageDetails?.cost_service_price,
          MaximumDiscount: packageDetails?.max_discount,
          DefaultDiscount: packageDetails?.default_discount,
          qualifying_condition: packageDetails?.qualifying_condition,
          calculation_self_assessment: packageDetails?.calculation_self_assessment,
        });
   
        await getAllService(serviceIds, packageDetails?.PackageEnterDefaultValues);


      } else {

      }
    } catch (error) {
      console.log("Error in ViewPackage", error);
    }
  };



  const ServiceApplicable = async () => {
    const req = { token: token, agent_id: agent_id };
    try {
      const res = await dispatch(getServiceApplicable(req)).unwrap();
      if (res.status) {
        setServiceApplicableData(res.data);
      } else {
        setServiceApplicableData([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // useEffect(() => {
  //   getAllService();
  // }, []);

  const getAllService = async (serviceIds, existingArray) => {
    const req = {
      agent_id: agent_id,
    };
    await dispatch(allPackageService(req))
      .unwrap()
      .then(async (response) => {
        if (response.status) {

          const matchedArray = response.data;
          let filteredServices = matchedArray.filter(service => serviceIds.includes(service.id));
          setcheckedList(filteredServices);
          EnterDefaultValueFun(filteredServices, existingArray);
          setAllServiceData(matchedArray);

        } else {
          setServiceList([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching charge basis data:", error);
      });
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (name === "DefaultPrice") {
      const isValid = /^[0-9]*\.?[0-9]*$/.test(value);
      if (isValid) {
        if (Number(value) > Number(serviceData.TotalCost)) {
          setServiceData({ ...serviceData, [name]: serviceData.TotalCost });
          validate(name, serviceData.TotalCost);
        } else {
          setServiceData({ ...serviceData, [name]: value });
          validate(name, value);
        }
      }
    } else if (name == "MinimunPrice") {
      const isValid = /^[0-9]*\.?[0-9]*$/.test(value);
      if (isValid) {
        if (Number(value) > Number(serviceData.DefaultPrice)) {
          setServiceData({ ...serviceData, [name]: serviceData.DefaultPrice });
          validate(name, value);
        } else {
          setServiceData({ ...serviceData, [name]: value });
          validate(name, value);
        }
      }
    }
    else if (name == "status") {
      let checked = e.target.checked;
      if (checked == true) {
        value = "1"
      } else {
        value = "0"
      }
      setServiceData({ ...serviceData, [name]: value });
    }
    else if (name == "qualifying_condition") {
      let checked = e.target.checked;
      if (checked == true) {
        value = "1"
      } else {
        value = "0"
      }
      setServiceData({ ...serviceData, [name]: value });
    }
    else if (name == "calculation_self_assessment") {
    
      if(value == ''){
        if (parseFloat(value) < 0 || parseFloat(value) == 0) {
          value = 1;
        }
        setServiceData({ ...serviceData, [name]: Number(value) });
        validate(name, Number(value));
  
        }else{
        const isValid = /^[0-9]+$/.test(value);
        if (!isValid) {
          return
        }
        setServiceData({ ...serviceData, [name]: Number(value) });
        validate(name, Number(value));
  
        }
    }
    else {
      setServiceData({ ...serviceData, [name]: value });
      validate(name, value);
    }
  };


  const validateAllFields = () => {
    let isValid = true;
    for (const key in serviceData) {
      if (!validate(key, serviceData[key])) {
        isValid = false;
      }
    }
    return isValid;
  };

  const validate = (name, value) => {
    const newErrors = { ...error };

    if (!value) {
      switch (name) {
        case "packageName":
          newErrors.packageName = EMPTY_PACKAGE_NAME_ERROR;
          break;
        case "applicableTo":
          newErrors.applicableTo = EMPTY_APPLICABLE_TO_ERROR;
          break;
        case "DefaultPrice":
          newErrors.DefaultPrice = EMPTY_DEFAULT_PACKAGE_PRICE_ERROR;
          break;
        // case "ThresholdPrice":
        //   newErrors.ThresholdPrice = EMPTY_THRESHOLD_PRICE_ERROR;
        //   break;
        case "MinimunPrice":
          newErrors.MinimunPrice = EMPTY_MINIMUM_PRICE_ERROR;
          break;
        default:
          break;
      }
    } else if (name == "applicableTo") {
      if (value.length == 0) {
        newErrors.applicableTo = EMPTY_APPLICABLE_TO_ERROR;
      } else {
        delete newErrors.applicableTo;
        setError((prevErrors) => {
          const updatedErrors = { ...prevErrors };
          delete updatedErrors.applicableTo;
          return updatedErrors;
        });
      }
    } else {
      delete newErrors[name];
      setError((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }

    if (Object.keys(newErrors).length !== 0) {
      setError((prevErrors) => ({
        ...prevErrors,
        ...newErrors,
      }));
    }

    ScrollToViewFirstError(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  useEffect(() => {
    const unmatchedArray = allServiceData.filter(
      (item1) => !checkedList.some((item2) => item1.id === item2.id)
    );
    setServiceList(unmatchedArray);

    const totalCost = checkedList.reduce((acc, service) => {
      const price = servicePriceCalculation(service);
      return acc + (parseFloat(price) || 0);
    }, 0);

    setServiceData({
      ...serviceData,
      TotalCost: totalCost,
      DefaultPrice: Math.min(serviceData.DefaultPrice, totalCost),
      MinimunPrice: Math.min(
        serviceData.MinimunPrice,
        Math.min(serviceData.DefaultPrice, totalCost)
      ),
    });

    setError((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.TotalCost;
      return updatedErrors;
    });

  }, [checkedList, enterDefaultValue ,serviceData.calculation_self_assessment]);

  useEffect(() => {
    let updatedData = { ...serviceData };
    let updatedErrors = { ...error };
    if (serviceData.DefaultPrice && serviceData.TotalCost) {
      let temp = serviceData.TotalCost - serviceData.DefaultPrice;
      let getPercentage = (temp / serviceData.TotalCost) * 100;
      updatedData.DefaultDiscount = getPercentage;
      delete updatedErrors.DefaultDiscount;
    }

    if (serviceData.DefaultPrice && serviceData.MinimunPrice) {
      let temp = serviceData.TotalCost - serviceData.MinimunPrice;
      let getPercentage = (temp / serviceData.TotalCost) * 100;
      updatedData.MaximumDiscount = getPercentage;
      delete updatedErrors.MaximumDiscount;
    }

    setServiceData(updatedData);
    setError(updatedErrors);
  }, [
    serviceData.DefaultPrice,
    serviceData.TotalCost,
    serviceData.MinimunPrice
  ]);

  const toggleCheckedService = (service,e) => {

    let hasBasisTypeId5 = service?.ServiceChargeBases?.some(item => item.ChargeBasis.BasisType.id === 5);
    if(hasBasisTypeId5 == true){
 
     if(e.target.checked == true){
     setServiceData({
       ...serviceData,
       calculation_self_assessment: 1,
     });
   }else{
     setServiceData({
       ...serviceData,
       calculation_self_assessment: 0,
     });
    }
   }




    const isAlreadyChecked = checkedList.some((item) => item.id === service.id);
    const updatedList = isAlreadyChecked
      ? checkedList.filter((item) => item.id !== service.id)
      : [...checkedList, service];
    EnterDefaultValueFun(updatedList, existEenterDefaultValue);
  };

  const EnterDefaultValueFun = async (data, existingArray) => {
    const PackageEnterDefaultValues = [];
    data?.forEach(service => {
      const {
        default_chargebasis_status,
        default_chargebasis_id,
        ServiceChargeBases,
        frequency_status,
        frequency_optional_chargebasis_id,
        link_frequency_rule,
        id: service_id
      } = service;

      const isDefaultSet = default_chargebasis_status === "1" && default_chargebasis_id;
      const isNonDefault = default_chargebasis_status === "0" && default_chargebasis_id === null;
      const defaultBasis = ServiceChargeBases.find(b => b.chargebasis_id === default_chargebasis_id);

      const processBasis = (basis) => {
        const basisId = basis?.ChargeBasis?.id;
        const basisTypeId = basis?.ChargeBasis?.BasisType?.id;
        const chargebases_name = basis?.ChargeBasis?.name;
        const chargetype_rule_id = basis?.ServiceChargeBasisValues?.[0]?.chargetype_rule_id ?? null;

       // if (!basisId || !chargebases_name || Number(basisTypeId) == 5) return;
        if (!basisId || !chargebases_name) return;

        let existing = PackageEnterDefaultValues.find(e => e.chargebases_id === basisId);
        if (!existing) {
          existing = {
            chargebases_id: basisId,
            chargebases_name,
            chargetype_rule_id,
            inputValue: 0,
            basisTypeId,
            radio_option: "0",
            dropdown: [], // dropdown empty initially
          };
          PackageEnterDefaultValues.push(existing);
        }
        // Handle dropdowns only for basisTypeId 3 or 4
        if ([3, 4].includes(Number(basisTypeId))) {
          basis?.ServiceChargeBasisValues?.forEach(val => {
            if (!val?.ChargeType?.id) return;
            let drop = existing.dropdown.find(d => d.id === val.ChargeType.id);
            if (!drop) {
              drop = {
                id: val.ChargeType.id,
                name: val.ChargeType.name,
                chargetype_rule_id: val.chargetype_rule_id,
                service: [],
              };
              existing.dropdown.push(drop);
            }

            if (!drop.service.some(s => s.service_id === service_id)) {
              drop.service.push({
                service_id,
                inputValue: val.value,
              });
            }
          });
        }
      };


      if (isDefaultSet) {
        const basisTypeId = defaultBasis?.ChargeBasis?.BasisType?.id;
        if ([3, 4].includes(Number(basisTypeId))) {
          const matchingBasis = ServiceChargeBases.filter(b => b.chargebasis_id === default_chargebasis_id);
          matchingBasis.forEach(processBasis);
        } else if (defaultBasis) {
          processBasis(defaultBasis);
        }
      }

      if (isNonDefault) {
        
        if((Number(frequency_status) == 1) && Number(link_frequency_rule) == 1) {
          const matchedChargeBases = ServiceChargeBases?.filter((item) => item?.ChargeBasis?.BasisType?.id !== 2)
           matchedChargeBases.forEach(processBasis);
        }
     
        else if ((Number(frequency_status) == 1) && frequency_optional_chargebasis_id) {
          const matchedChargeBases = ServiceChargeBases.filter(
            item =>
              (item.chargebasis_id) === frequency_optional_chargebasis_id ||
              item?.ChargeBasis?.BasisType?.id === 4
          );
          matchedChargeBases.forEach(processBasis);
        } else {
           const matchedChargeBases = ServiceChargeBases?.filter((item) => item?.ChargeBasis?.BasisType?.id !== 2)
          matchedChargeBases.forEach(processBasis);

         //ServiceChargeBases.forEach(processBasis);
        }

      }
    });

    
    let updatedArray = PackageEnterDefaultValues?.map(sourceItem => {
      let match = existingArray?.find(
        exist => exist.chargebases_id === sourceItem.chargebases_id
      );
      if (match) {
        return {
          ...sourceItem,
          chargetype_rule_id: match.chargetype_rule_id,
          inputValue: match.inputValue,
          id: match.id,
          package_id: match.package_id,
          radio_option: match.radio_option,
        };
      }
      return sourceItem;
    });
    setEnterDefaultValue(updatedArray);

    

  }


  const handleEnterDefaultValue = (index, e) => {
    let { name, value } = e.target;
    // if (name == "input") {
    //   if (parseFloat(value) < 0 || parseFloat(value) == 0) {
    //     value = 1;
    //   }
    //   const updatedCharges = [...enterDefaultValue];
    //   updatedCharges[index].inputValue = value;
    //   setEnterDefaultValue(updatedCharges);
    // }
    if (name === "input") {

      if(value == ''){
      if (parseFloat(value) < 0 || parseFloat(value) == 0) {
        value = 1;
      }
      const updatedCharges = [...enterDefaultValue];
      updatedCharges[index].inputValue = value;
      setEnterDefaultValue(updatedCharges);

      }else{
      const isValid = /^[0-9]+$/.test(value);
      if (!isValid) {
        return
      }
      const updatedCharges = [...enterDefaultValue];
      updatedCharges[index].inputValue = value;
      setEnterDefaultValue(updatedCharges);

      }

    }
    else if (name == "dropdown") {
      const updatedCharges = [...enterDefaultValue];
      updatedCharges[index].chargetype_rule_id = Number(value);
      setEnterDefaultValue(updatedCharges);
    }

    else if (name.startsWith("radioOption")) {
      const updatedCharges = [...enterDefaultValue];
      updatedCharges[index].radio_option = value;
      setEnterDefaultValue(updatedCharges);
    }
  };

  function servicePriceCalculation(service) {
    // Case 1 Default Charge Basis Calculation
    if (service.default_chargebasis_id != null && Number(service.default_chargebasis_status) == 1) {
      const defaultBasis = service.ServiceChargeBases.find(
        b => b.chargebasis_id === service.default_chargebasis_id
      );

      const basisTypeId = defaultBasis?.ChargeBasis?.BasisType?.id;
      if ([3, 4].includes(Number(basisTypeId))) {
        const inputValue = (() => {
          const matchedItem = enterDefaultValue.find(
            item => item.chargebases_id === defaultBasis.chargebasis_id
          );
          return (
            matchedItem?.dropdown
              ?.find(d => d.chargetype_rule_id === matchedItem.chargetype_rule_id)
              ?.service
              ?.find(s => s.service_id === defaultBasis.service_id)
              ?.inputValue || null
          );
        })();

        if (inputValue != null) {
          return parseFloat(inputValue);
        } else {
          return '-';
        }
      } else {


        const inputValue = enterDefaultValue.find(item => item.chargebases_id === defaultBasis.chargebasis_id)?.inputValue;

        let rate_cutoff = defaultBasis?.rate_cutoff || null;
        let add_on_price = defaultBasis?.add_on_price || null;

        let extraPrice = 0;

        if (rate_cutoff != null &&  inputValue > rate_cutoff) {
          let intervals = Math.ceil((inputValue - rate_cutoff) / rate_cutoff);
          extraPrice = intervals * add_on_price;
        }
        


        if (inputValue != null && defaultBasis.price_rate != null) {
          let calculatPrice = parseFloat(inputValue) * parseFloat(defaultBasis.price_rate);
          if (calculatPrice > 0) {
            if (calculatPrice < parseFloat(defaultBasis.min_base_price)) {
              
               if (rate_cutoff != null && Number(inputValue) > parseFloat(rate_cutoff)) {
                return defaultBasis.min_base_price + extraPrice;
              } else {
                return defaultBasis.min_base_price;
              }
            } else {
              if (rate_cutoff != null && Number(inputValue) > parseFloat(rate_cutoff)) {
                calculatPrice = parseFloat(rate_cutoff) * parseFloat(defaultBasis.price_rate);
                return calculatPrice + extraPrice;
              } else {
                return calculatPrice;
              }
            
            }
          } else {
            return 0;
          }
        } else {
          return '-';
        }

      }


    }
    // Case 2 Use Incremental Rule Calculation
    else if (Number(service.incremental_rule == 1)) {

      const filtered = service?.ServiceChargeBases?.filter(base => {
        const match = enterDefaultValue?.find(input => input.chargebases_id === base.chargebasis_id);
        if (!match) return false;
    
        if (match.basisTypeId === 5) {
            return match.radio_option === "1";
        }
    
        return true;
    });
    
    const isOnlyOneWithBasisTypePerUnit = filtered.length === 1 && filtered[0].ChargeBasis?.BasisType?.id === 1;
    const type5Prices = filtered?.filter(item => item.ChargeBasis?.BasisType?.id === 5).map(item => item.min_base_price);
    const type5PricesAll = filtered?.filter(item => item.ChargeBasis?.BasisType?.id === 5);

      if (new Set(type5Prices).size === type5Prices.length) {
        // •	Scenario 1
       // let total = type5Prices.reduce((sum, price) => sum + (price || 0), 0);

       let total = 0;
       if(type5PricesAll.length > 0) {
        const maxMin = Math.max(...type5PricesAll.map(d => d.min_base_price));
         total = type5PricesAll.reduce((sum_val, d) =>
          sum_val + (d.min_base_price === maxMin ? 0 : (d.incremental_price ?? d.min_base_price)), maxMin
        );
       }

        const PerUnitChargeBasis = filtered?.find(
          item => Number(item?.ChargeBasis?.BasisType?.id) === 1
        );
        if(PerUnitChargeBasis){
        const inputValue = enterDefaultValue.find(item => item.chargebases_id === PerUnitChargeBasis.chargebasis_id)?.inputValue;
        
        if (inputValue != null && PerUnitChargeBasis?.price_rate != null) {

          if(parseInt(inputValue) > 0){
          let calculatPrice = parseFloat(inputValue) * parseFloat(PerUnitChargeBasis?.price_rate);
          if (isOnlyOneWithBasisTypePerUnit == true && calculatPrice < parseFloat(PerUnitChargeBasis?.min_base_price)) {
            return serviceData.calculation_self_assessment*(total + PerUnitChargeBasis?.min_base_price);
          } else {
            return serviceData.calculation_self_assessment*(total + calculatPrice);
          }

        }else{
          return serviceData.calculation_self_assessment*(total + 0);
        }



        } else {
          return serviceData.calculation_self_assessment*(total + 0); 
        }
      }else{
        return serviceData.calculation_self_assessment*(total + 0);
      }



      } else {
        // •	Scenario 2
        const selfAssessments = filtered?.filter(
          item => Number(item?.ChargeBasis?.BasisType?.id) === 5
        );

        // Step 1: Group by base prices
        const basePriceGroups = {};
        selfAssessments.forEach(item => {
          const base = item.min_base_price;
          if (!basePriceGroups[base]) basePriceGroups[base] = [];
          basePriceGroups[base].push(item);
        });

        // Step 2: Find the max base price
        const allBasePrices = Object.keys(basePriceGroups).map(Number);
        const maxBasePrice = Math.max(...allBasePrices);
        const maxBaseGroup = basePriceGroups[maxBasePrice];

        // Step 3: Determine base entry
        let baseEntry;
        if (maxBaseGroup.length === 1) {
          // Unique max base price
          baseEntry = maxBaseGroup[0];
        } else {
          // Duplicate base prices – pick with lowest incremental price
          baseEntry = maxBaseGroup.reduce((lowest, item) =>
            item.incremental_price < lowest.incremental_price ? item : lowest
          );
        }

        // Step 4: Get other items (excluding baseEntry)
        const otherSelfAssessments = selfAssessments.filter(item => item.id !== baseEntry.id);

        // Step 5: Final calculation
        const basePrice = baseEntry.min_base_price;
        const incrementalTotal = otherSelfAssessments.reduce(
          (acc, item) => acc + (item.incremental_price || 0),
          0
        );
        let total = basePrice + incrementalTotal;

       

        // Step 4: Get Per Unit Charge Basis
        const PerUnitChargeBasis = filtered?.find(
          item => Number(item?.ChargeBasis?.BasisType?.id) === 1
        );
        if(PerUnitChargeBasis){
        const inputValue = enterDefaultValue.find(item => item.chargebases_id === PerUnitChargeBasis.chargebasis_id)?.inputValue;
        if (inputValue != null && PerUnitChargeBasis?.price_rate != null) {
          if(parseInt(inputValue) > 0){
          let calculatPrice = parseFloat(inputValue) * parseFloat(PerUnitChargeBasis?.price_rate);
          if (isOnlyOneWithBasisTypePerUnit == true && calculatPrice < parseFloat(PerUnitChargeBasis?.min_base_price)) {
            return serviceData.calculation_self_assessment*(total + PerUnitChargeBasis?.min_base_price);

          } else {
            return serviceData.calculation_self_assessment*(total + calculatPrice);
          }
        }else{
          return serviceData.calculation_self_assessment*(total + 0);
        }

        } else {
          return serviceData.calculation_self_assessment*(total + 0);
        }
      }else{
        return serviceData.calculation_self_assessment*(total + 0);
      }

      }

    }

     // Case 3 Use Frequency Custom Rule Calculation
    else if (Number(service.custom_rule == 1) && Number(service.link_frequency_rule == 1)) {
      return CustomRuleCalculateTotalPrice(service?.ServiceChargeBases?.filter((item) => Number(item?.ChargeBasis?.BasisType?.id) !== 2));
    }

    // Case 4 Use Custom Rule Calculation
    else if (Number(service.custom_rule == 1)) {
   
      // Frequency Rule Calculation
      if (Number(service.frequency_status == 1)) {

        const frequencyChargeBasisAll = service?.ServiceChargeBases?.filter(
          item =>
            (item.chargebasis_id) === service?.frequency_optional_chargebasis_id ||
            item?.ChargeBasis?.BasisType?.id === 4
        );

        const singleFrequencyChargeBasis = frequencyChargeBasisAll?.find(item => item?.ChargeBasis?.BasisType?.id === 4);

        const otherFrequencyChargeBasis = frequencyChargeBasisAll?.find(item => item?.ChargeBasis?.BasisType?.id !== 4);

        const singleFrequencyChargeBasisPrice = FrequencyRulePriceSingleChareBasis(singleFrequencyChargeBasis);

        let extraPrice = 0;
        let otherFrequencyBasisTypeId = otherFrequencyChargeBasis?.ChargeBasis?.BasisType?.id;
        if (Number(otherFrequencyBasisTypeId) === 1) {
          const inputValue = enterDefaultValue?.find(item => item.chargebases_id === otherFrequencyChargeBasis.ChargeBasis.id)?.inputValue;

          let rate_cutoff = otherFrequencyChargeBasis?.rate_cutoff || null;
          let add_on_price = otherFrequencyChargeBasis?.add_on_price || null;

          if (rate_cutoff != null &&  inputValue > rate_cutoff) {
            let intervals = Math.ceil((inputValue - rate_cutoff) / rate_cutoff);
            extraPrice = intervals * add_on_price;
          }
        }

        const otherFrequencyChargeBasisPrice = FrequencyRulePriceSingleChareBasis(otherFrequencyChargeBasis);
        if (singleFrequencyChargeBasisPrice != null && otherFrequencyChargeBasisPrice != null) {
          const operator = singleFrequencyChargeBasis.operator;
          const left = parseFloat(otherFrequencyChargeBasisPrice);
          const right = parseFloat(singleFrequencyChargeBasisPrice);
         switch (operator) {
            case '+':
              return (left + right) + extraPrice;
            case '-':
              return (left - right) + extraPrice;
            case '*':
              return (left * right) + extraPrice;
            case '/':
              return right !== 0 ? (left / right) + extraPrice : 0;
            default:
              return 0;
          }
        }


      } else {
        return CustomRuleCalculateTotalPrice(service?.ServiceChargeBases?.filter((item) => Number(item?.ChargeBasis?.BasisType?.id) !== 2));
        //return CustomRuleCalculateTotalPrice(service.ServiceChargeBases);
      }
    }

  }

  //Frequency Custom Rule Calculation
  const FrequencyRulePriceSingleChareBasis = (singleFrequencyChargeBasis) => {
    const basisTypeId = singleFrequencyChargeBasis?.ChargeBasis?.BasisType?.id;
    let singleFrequencyChargeBasisPrice = 0;
    if ([3, 4].includes(Number(basisTypeId))) {
      const inputValue = (() => {
        const matchedItem = enterDefaultValue.find(
          item => item.chargebases_id === singleFrequencyChargeBasis.chargebasis_id
        );
        return (
          matchedItem?.dropdown
            ?.find(d => d.chargetype_rule_id === matchedItem.chargetype_rule_id)
            ?.service
            ?.find(s => s.service_id === singleFrequencyChargeBasis.service_id)
            ?.inputValue || null
        );
      })();

      if (inputValue != null) {
        singleFrequencyChargeBasisPrice = parseFloat(inputValue);
      } else {
        singleFrequencyChargeBasisPrice = 0
      }
    } else {
      const inputValue = enterDefaultValue?.find(item => item.chargebases_id === singleFrequencyChargeBasis.chargebasis_id)?.inputValue;

      let rate_cutoff = singleFrequencyChargeBasis?.rate_cutoff || null;
      let add_on_price = singleFrequencyChargeBasis?.add_on_price || null;

      
      if (inputValue != null && singleFrequencyChargeBasis.price_rate != null) {
        if (parseInt(inputValue) > 0) {
          let calculatPrice = parseFloat(inputValue) * parseFloat(singleFrequencyChargeBasis.price_rate);
          if (calculatPrice < parseFloat(singleFrequencyChargeBasis.min_base_price)) {
            singleFrequencyChargeBasisPrice = singleFrequencyChargeBasis.min_base_price;
          } else {
            if (rate_cutoff != null && Number(inputValue) > parseFloat(rate_cutoff)) {
              calculatPrice = parseFloat(rate_cutoff) * parseFloat(singleFrequencyChargeBasis.price_rate);
              singleFrequencyChargeBasisPrice = calculatPrice;
            } else {
              singleFrequencyChargeBasisPrice = calculatPrice;
            }
          }
        } else {
          singleFrequencyChargeBasisPrice = 0
        }
      } else {
        singleFrequencyChargeBasisPrice = 0
      }

    }
    return singleFrequencyChargeBasisPrice
  }

  //Basic Custom Rule Calculation
  const CustomRuleCalculateTotalPrice = (serviceChargeBases) => {
    const sortedChargeBases = [...serviceChargeBases].sort(
      (a, b) => a.chargebasis_asc_order - b.chargebasis_asc_order
    );
    let total = null;
    let extraPrice = 0;
    sortedChargeBases.forEach((item, index) => {
      let otherFrequencyChargeBasis = item
      const price = FrequencyRulePriceSingleChareBasis(item);

      let otherFrequencyBasisTypeId = otherFrequencyChargeBasis?.ChargeBasis?.BasisType?.id;
      if (Number(otherFrequencyBasisTypeId) === 1) {
        const inputValue = enterDefaultValue?.find(item1 => item1.chargebases_id === otherFrequencyChargeBasis.ChargeBasis.id)?.inputValue;

        let rate_cutoff = otherFrequencyChargeBasis?.rate_cutoff || null;
        let add_on_price = otherFrequencyChargeBasis?.add_on_price || null;

        if (rate_cutoff != null &&  inputValue > rate_cutoff) {
          let intervals = Math.ceil((inputValue - rate_cutoff) / rate_cutoff);
          extraPrice += intervals * add_on_price;
        }
      }


      if (index === 0) {
        total = price;
      } else {
        const operator = item.operator;
        switch (operator) {
          case '+':
            total += price;
            break;
          case '-':
            total -= price;
            break;
          case '*':
            total *= price;
            break;
          case '/':
            total = price !== 0 ? total / price : total; // avoid divide by 0
            break;
          default:
            break;
        }
      }
    });
   return total !== null ? total + extraPrice : 0;
  };


 

  const handleSubmitPackage = async () => {
    const invalidObject = checkedList.find((obj) => obj.price === null);
    const isValid = invalidObject === undefined;

    if (!isValid) {
      sweatalert.fire({
        title: "Warning",
        text: "Please enter default value for all services",
        icon: "warning",
        confirmButtonText: "OK",
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }

    const isValid1 = validateAllFields();
    if (!isValid1) {
      return;
    }


    if(isSelAssement == true && parseInt(serviceData.calculation_self_assessment)  < 1){
          sweatalert.fire({
            title: "Warning",
            text: "Self-Assessment Input Value should be greater than 0",
            icon: "warning",
            confirmButtonText: "OK",
             timer: 3000,
            timerProgressBar: true,
          });
          return;
     }

    const req = {
      id: location?.state?.row?.id || id,
      user_id: user_id,
      agent_id: agent_id,
      name: serviceData.packageName,
      applicable: (serviceData?.applicableTo?.map((item) => item.value)).join(','),
      description: serviceData.PackageDescription,
      default_price: serviceData.DefaultPrice,
      min_price: serviceData.MinimunPrice,
      cost_service_price: serviceData.TotalCost,
      minimum_discount: serviceData.DefaultDiscount,
      max_discount: (serviceData.MaximumDiscount).toFixed(2),
      default_discount: (serviceData.DefaultDiscount).toFixed(2),
      status: serviceData.status,
      qualifying_condition: serviceData.qualifying_condition,
      calculation_self_assessment : serviceData.calculation_self_assessment,
      PackageServices: checkedList.map((service) => {
        const exists = existServiceIds.includes(service.id);
        return {
          service_id: service.id,
          price: servicePriceCalculation(service),
          exists: exists,
        };
      }),
      PackageEnterDefaultValues: enterDefaultValue?.map((item) => {
        return {
          id: item.id || null,
          package_id: item.package_id || null,
          chargebases_id: item.chargebases_id,
          chargetype_rule_id: item.chargetype_rule_id,
          inputValue: item.inputValue,
          radio_option: item.radio_option,
        };
      }),
    };
   



    await dispatch(updatePackage(req)).unwrap()
      .then((res) => {
        if (res.status) {
          sweatalert.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            confirmButtonText: "OK",
            timer: 3000,
            timerProgressBar: true,
          });
          navigate("/admin/pricing/all-packages");
        } else {
          sweatalert.fire({
            title: "Error",
            text: res.message,
            icon: "error",
            confirmButtonText: "OK",
            timer: 3000,
            timerProgressBar: true,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };


  return (
    <div>
      <div className="row ">
        <div className="col">
          {/* <h4 className="page-title">Edit Package</h4> */}
          <h4 className="page-title">
          <button className="btn p-0 fs-5" onClick={() => { window.history.back() }}>
                <i className="bx bx-arrow-back text-pink"></i>
              </button> Package
              <span>
                <i className=" ri-arrow-right-s-line"></i> {serviceData?.packageName || ""}
              </span>
              </h4>

        </div>

      </div>
      <div className="card form-card">
        <div className="card-header d-sm-flex justify-content-between align-items-center ">
          <div>
            <h5 className="card-title mb-0">Edit Package</h5>
          </div>

          <div className="">
            <div className="d-flex justify-content-sm-center  justify-content-lg-start align-items-center">
              <label htmlFor="status" className=" col-form-label py-0">
                Status:
              </label>

              <div className="form-switch ms-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  name="status"
                  checked={serviceData.status == "1" ? true : false}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card-body px-lg-3 px-0">
          <div className=" needs-validation">
            <div className="row ">
              <div className="col-md-6">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label ">
                    Package Name:
                  </label>
                  <div className="col-md-8  col-sm-8 ">
                    <input
                      type="text"
                      className="form-control"
                      name="packageName"
                      id="packageName"
                      value={serviceData.packageName}
                      
                      onChange={handleInputChange}
                      placeholder="Enter package name"
                    />
                    {error.packageName && (
                      <div className="error-text">{error.packageName}</div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row mb-3">
                  <label className="col-sm-4 col-form-label ">
                    Applicable to:
                  </label>
                  <div className="col-md-8  col-sm-8 ">
                    <Select
                      options={serviceApplicableData?.map((data) => {
                        return { label: data.name, value: data.name };
                      })}
                      isMulti
                      closeMenuOnSelect={false}
                      className="basic-multi-select"
                      name="applicableTo"
                      id="applicableTo"
                      value={serviceData.applicableTo}
                      onChange={(e) => {
                        setServiceData({ ...serviceData, applicableTo: e });
                        validate("applicableTo", e);
                      }}
                      placeholder="Select options"
                    />
                    {error?.applicableTo && (
                      <div className="error-text">{error.applicableTo}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="row ">
              <div className="col-md-12">
                <div className="row mb-3">
                  <label className="col-sm-4 col-md-2 col-form-label ">
                    Package description:
                  </label>
                  <div className="col-sm-8 col-md-10 ">
                    <textarea
                      ref={textareaRef}
                      className="form-control"
                      value={serviceData.PackageDescription}
                      name="PackageDescription"
                      onChange={handleInputChange}
                      placeholder="Enter package description"
                      style={{
                        width: "100%",
                        minHeight: "40px",
                        maxHeight: "300px",
                        overflowY: "hidden",
                        padding: "8px",
                        fontSize: "16px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-10 ms-auto">
                <div className="card shadow-none border ">
                  <div className="card-header d-sm-flex mb-0">
                    <label className="col-form-label ">Add Services:</label>

                    <div className="search-form d-flex align-items-center ms-2">
                      <input
                        type="search"
                        className="form-control"
                        name="addServices"
                        value={serviceData.addServices}
                        onChange={handleInputChange}
                        placeholder="Search Services"
                        title="Search services"
                      />
                    </div>

                    <div className="d-flex align-items-center justify-content-end ms-auto">
                      <label className="col-form-label mb-0">Total Included Services:</label>

                      <div className="ms-2">
                        <span className="form-control-plaintext">{checkedList?.length > 0 ? checkedList?.length : 0}</span>
                      </div>
                    </div>

                  </div>
                  <div className="">
                    <div className="service-table-container">
                      <table className="table table-striped ">
                        <thead>
                          <tr>
                            <td style={{ background: '#F5F5F5', color: '#4E4E4E', fontSize: '14px' }}>Service Name</td>
                            <td style={{ background: '#F5F5F5', color: '#4E4E4E', fontSize: '14px' }}>Charge Basis</td>

                            <td style={{ background: '#F5F5F5', color: '#4E4E4E', fontSize: '14px' }}>Default Price</td>
                          </tr>
                        </thead>
                        <tbody>

                          {checkedList?.map((service) => (
                            <tr key={service?.id}>
                              <td>
                                <div className="d-flex">
                                  <div className="form-check me-3">
                                    <input
                                      type="checkbox"
                                      defaultChecked
                                      onClick={
                                        (e) => {
                                          if (checkedList?.includes(service)) {
                                            setcheckedList(checkedList?.filter((item) => item?.id != service?.id));
                                            toggleCheckedService(service,e);
                                            getAllService();
                                          } else {
                                            setcheckedList([...checkedList, service]);
                                            toggleCheckedService(service,e);
                                            getAllService();
                                          }

                                        }
                                      }
                                      className="form-check-input">
                                    </input>
                                  </div>
                                  <div className="text-pink"> {service?.name}</div>
                                </div>
                              </td>
                              <td>
                                {Number(service?.default_chargebasis_status) == 1
                                  ?
                                  service?.ServiceChargeBases?.find(
                                    (item) => Number(item?.chargebasis_id) == Number(service?.default_chargebasis_id)
                                  )?.ChargeBasis?.name

                                  : '-'}
                              </td>

                              {/* <td>{"CheckedList"}</td> */}
                              <td>{servicePriceCalculation(service)}</td>
                            </tr>
                          ))}




                          {serviceList?.map(
                            (service) =>

                              service?.ServiceChargeBases?.find(
                                (item) => Number(item?.chargebasis_id) == Number(service?.default_chargebasis_id)
                              )?.ChargeBasis?.BasisType?.id !== 2 &&

                              
                              service.name
                                .toLowerCase()
                                .includes(
                                  serviceData.addServices.toLowerCase()
                                ) && (
                                <tr key={service?.id}>
                                  <td className="border-0">
                                    <div className="d-flex">
                                      <div className="form-check me-3">
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          onClick={(e) => {
                                            if (
                                              checkedList?.includes(service)
                                            ) {
                                              setcheckedList(
                                                checkedList?.filter(
                                                  (item) =>
                                                    item?.id != service?.id
                                                )
                                              );
                                              toggleCheckedService(service,e);
                                            } else {
                                              setcheckedList([
                                                ...checkedList,
                                                service,
                                              ]);
                                            }
                                            toggleCheckedService(service,e);
                                          }}
                                        ></input>
                                      </div>
                                      <div className="text-pink">
                                        {" "}
                                        {service?.name}
                                      </div>
                                    </div>
                                  </td>
                                  <td className="border-0">
                                    {Number(service?.default_chargebasis_status) == 1
                                      ?
                                      service?.ServiceChargeBases?.find(
                                        (item) => Number(item?.chargebasis_id) == Number(service?.default_chargebasis_id)
                                      )?.ChargeBasis?.name

                                      : '-'}
                                  </td>
                                  <td className="border-0">
                                    <td>{"-"}</td>
                                  </td>
                                </tr>
                              )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

        
            <div className="gray-card mt-4">
              <div className="card-header bg-transparent pt-0 ">
                <div>
                  <h5 className="card-title mb-0">Enter Default Values</h5>
                </div>
              </div>

               {enterDefaultValue?.map((item, index) => (
                <div className="row w-100 mx-auto border-bottom pt-3" key={item.chargebases_id}>
                  <div className="col-md-6">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label ">
                        {item.chargebases_name}:
                      </label>
                      <div className="col-md-8  col-sm-8 ">
                        {(item?.basisTypeId === 3 || item?.basisTypeId === 4) && item?.dropdown.length > 0 ?

                          <select
                            className="form-select"
                            name="dropdown"
                            id="enterDefaultValue"
                            value={item.chargetype_rule_id}
                            onChange={(e) =>
                              handleEnterDefaultValue(index, e)
                            }
                          >
                            {item.dropdown?.map((d) => (
                              <option key={d.id}
                                value={d.id}
                                selected={d.id === item.chargetype_rule_id}
                              >
                                {d.name}
                              </option>
                            ))}
                          </select>

                          :

                          item?.basisTypeId === 5 ?
                         <>
                          <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name={`radioOption-${index}`} // <-- make name unique
                            id={`yesRadio-${index}`}
                            value="1"
                            checked={Number(item.radio_option) === 1}
                            onChange={(e) => handleEnterDefaultValue(index, e)}
                          />
                          <label className="form-check-label" htmlFor={`yesRadio-${index}`}>
                            Yes
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name={`radioOption-${index}`} // <-- same name as above
                            id={`noRadio-${index}`}
                            value="0"
                            checked={Number(item.radio_option) === 0}
                            onChange={(e) => handleEnterDefaultValue(index, e)}
                          />
                          <label className="form-check-label" htmlFor={`noRadio-${index}`}>
                            No
                          </label>
                        </div>
                        </>

                            :

                            <input
                              type="text"
                              className="form-control"
                              name="input"
                              id="enterDefaultValue"
                              value={item.inputValue}
                              
                              onChange={(e) =>
                                handleEnterDefaultValue(index, e)
                              }
                              placeholder="Enter Default Value"
                            />


                        }

                      </div>


                    </div>
                  </div>
                </div>
              ))}

            </div>
    <div className="gray-card">
              <div className="card-header bg-transparent pt-0 ">
                <div>
                  <h5 className="card-title mb-0">Pricing Details</h5>
                </div>
              </div>
              <div className="row w-100 mx-auto">
                <div className="col-md-6">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label ">
                      Total cost of services:
                    </label>
                    <div className="col-md-8  col-sm-8 ">
                      <div className="input-group">
                        <span className="input-group-text" id="" disabled>
                          £
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          name="TotalCost"
                          value={Number(serviceData?.TotalCost)?.toFixed(2)}
                          onChange={handleInputChange}
                          placeholder="Enter total cost of services"
                          disabled
                        />
                      </div>
                      {error.TotalCost && (
                        <div className="error-text">{error.TotalCost}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label ">
                      Default price:
                    </label>
                    <div className="col-md-8  col-sm-8 ">
                      <div className="input-group">
                        <span className="input-group-text" id="">
                          £
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          name="DefaultPrice"
                          id="DefaultPrice"
                          value={serviceData.DefaultPrice}
                          onChange={handleInputChange}
                          placeholder="Enter default price"
                        />
                      </div>
                      {error.DefaultPrice && (
                        <div className="error-text">{error.DefaultPrice}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row w-100 mx-auto">
                <div className="col-md-6">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label ">
                      Minimum price:
                    </label>
                    <div className="col-md-8  col-sm-8 ">
                      <div className="input-group">
                        <span className="input-group-text" id="">
                          £
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          name="MinimunPrice"
                          id="MinimunPrice"
                          value={serviceData.MinimunPrice}
                          onChange={handleInputChange}
                          placeholder="Enter minimun price"
                        />
                      </div>
                      {error.MinimunPrice && (
                        <div className="error-text">{error.MinimunPrice}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label ">
                      Default discount:
                    </label>
                    <div className="col-md-8  col-sm-8 ">
                      <div className="input-group">
                        <span
                          className={`input-group-text border-right-0  ${serviceData?.DefaultDiscount ? "disabled-span" : ""
                            }`}
                          id=""
                        >
                          %
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          name="DefaultDiscount"
                          disabled
                          value={Number(serviceData?.DefaultDiscount)?.toFixed(
                            2
                          )}
                          onChange={handleInputChange}
                          placeholder="Enter default discount"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row w-100 mx-auto">
                <div className="col-md-6">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label ">
                      Maximum discount:
                    </label>
                    <div className="col-md-8  col-sm-8 ">
                      <div className="input-group">
                        <span
                          className={`input-group-text ${serviceData?.MaximumDiscount ? "disabled-span" : ""
                            }`}
                          id=""
                        >
                          %
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          name="MaximumDiscount"
                          disabled
                          value={Number(serviceData?.MaximumDiscount)?.toFixed(
                            2
                          )}
                          onChange={handleInputChange}
                          placeholder="Enter maximum discount"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label ">
                      Qualifying Conditions:
                    </label>
                    <div className="col-md-8  col-sm-8 ">
                      <div className="form-switch ms-2">

                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          name="qualifying_condition"
                          checked={serviceData.qualifying_condition == "1" ? true : false}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

           
              {
              //isSelAssement ? 
                 <div className="row w-100 mx-auto">
                 <div className="col-md-6">
                   <div className="row mb-3">
                     <label className="col-sm-4 col-form-label ">
                     Self-Assessment Input:
                     </label>
                     <div className="col-md-8  col-sm-8 ">
                         <input
                           type="text"
                           className="form-control"
                           name="calculation_self_assessment"
                           id="calculation_self_assessment"
                           value={serviceData.calculation_self_assessment}
                           onChange={handleInputChange}
                           placeholder="Self-Assessment Input"
                           disabled={isSelAssement ? false : true}
                         />
                       </div>
                       {error.calculation_self_assessment && (
                         <div className="error-text">{error.calculation_self_assessment}</div>
                       )}
                    
                   </div>
                 </div>
               </div>
               // :""
                }


            </div>
            <div className=" col-auto text-end mt-3">
              <button
                className="btn btn-outline-secondary rounded"
                onClick={() => navigate("/admin/pricing/all-packages")}
              >
                 <i className="fa fa-xmark pe-1"></i>
                Cancel
              </button>
              <button
                className="btn btn-pink ms-2 rounded "
                onClick={handleSubmitPackage}
              >
                <i className="far fa-save pe-1"></i>
                Update
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPackage;
